import React from 'react';
import { Button, Header } from 'semantic-ui-react';
import Event from '../../../darkmatter/Event';

export default ({ category, displayCategoriesAs }) => {
  if (displayCategoriesAs === 'button') {
    return (
      <Event
        event={{ category: 'Menu Navigation', action: 'Click', label: category }}
        eventType="click"
      >
        <Button primary as="a" href={`#${category}`}>
          {category}
        </Button>
      </Event>
    );
  }
  if (displayCategoriesAs === 'text') {
    return (
      <Event
        event={{ category: 'Menu Navigation', action: 'Click', label: category }}
        eventType="click"
      >
        <a href={`#${category}`}>{category}</a>
      </Event>
    );
  }
  return (
    <Event
      event={{ category: 'Menu Navigation', action: 'Click', label: category }}
      eventType="click"
    >
      <Header as="a" href={`#${category}`}>
        {category}
      </Header>
    </Event>
  );
};
